import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
export var assign = Object.assign || /* istanbul ignore next */
function assign(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  for (var i = 0; i < sources.length; i++) {
    if (!sources[i]) continue;
    var keys = Object.keys(sources[i]);
    for (var j = 0; j < keys.length; j++) {
      // eslint-disable-next-line no-param-reassign
      target[keys[j]] = sources[i][keys[j]];
    }
  }
  return target;
};